<template>
    <v-app>
        <portal-sysbar />
        <div class="main-content">
            <portal-aside />
            <portal-title :title="$t('message.aside.disponibility', { value: 'default' })" />
            <portal-breadcumb />
            <div class="content">
                <!-- filtres et widgets inchangés -->

                <v-row>
                    <v-col></v-col>
                    <v-col></v-col>
                </v-row>
                <!--Filter start-->
                <v-row class="mx-1 mb-2">
                    <v-card :color="getBgColor" flat class="rounded-xl" width="100%">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="4" md="3">
                                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                        :return-value.sync="date" transition="scale-transition" offset-y
                                        max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="payload.date" label="Picker in menu"
                                                append-icon="mdi-calendar" readonly outlined dense v-bind="attrs"
                                                v-on="on" hide-details solo></v-text-field>
                                        </template>
                                        <v-date-picker v-model="payload.date" type="month" no-title scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu = false">
                                                Cancel
                                            </v-btn>
                                            <v-btn text color="primary" @click="$refs.menu.save(date)">
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="4" md="3">
                                    <v-autocomplete :items="agreements"
                                        :label="$t('message.pageKm.contractnum', { value: 'default' })"
                                        item-value="agreement" item-text="agreement" outlined dense
                                        v-model="payload.agreement" hide-details solo>
                                    </v-autocomplete>
                                </v-col>
                                <v-col>
                                    <v-btn color="primary" @click="loadData" :loading="loading">OK</v-btn>
                                </v-col>
                                <v-col class="text-right">
                                    <v-btn color="green" :disabled="expBtn" fab class="mx-2" small @click="download()">
                                        <v-icon>
                                            mdi-file-excel
                                        </v-icon>
                                    </v-btn>

                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-row>
                <!--Filter end-->
                <!--Widget start-->
                <v-row class="mt-0 mb-1">
                    <v-col cols="8" class="pt-0">
                        <v-card :color="getBgColor" flat class="rounded-xl">
                            <v-card-text>
                                <div class="d-flex justify-start">
                                    <v-card flat class="text-center mr-2 rounded-xl">
                                        <v-card-text class="pb-0 text">
                                            <h4>{{ $t("message.dispoc.indisponibilite", { value: "default" }) }}</h4>
                                            <v-row>
                                                <v-col cols="4">
                                                    <h6>{{ $t("message.dispoc.causePreventive", { value: "default" }) }}
                                                    </h6>
                                                    <apex-charts type="radialBar" height="120" :options="chartOptions"
                                                        :series="cpSeries"></apex-charts>
                                                </v-col>
                                                <v-col cols="4">
                                                    <h6>{{ $t("message.dispoc.causeCorrective", { value: "default" }) }}
                                                    </h6>
                                                    <apex-charts type="radialBar" height="120" :options="chartOptions"
                                                        :series="cmSeries"></apex-charts>
                                                </v-col>
                                                <v-col cols="4">
                                                    <h6>{{ $t("message.dispoc.causeClient", { value: "default" }) }}
                                                    </h6>
                                                    <apex-charts type="radialBar" height="120" :options="chartOptions"
                                                        :series="dcSeries"></apex-charts>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <v-card flat class="text-center rounded-xl">
                                        <v-card-text class="pb-0">
                                            <h4>{{ $t("message.dispoc.dispGen", { value: "default" }) }}</h4>
                                            <apex-charts type="radialBar" height="200" :options="dgChartOptions"
                                                :series="dgSeries"></apex-charts>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="4" class="pt-0 ">
                        <v-card :color="getBgColor" flat class="rounded-xl">
                            <v-card-text class="pb-1 legende">
                                <p>
                                    <span class=" chip A1">A1</span>
                                    <span class="ml-1">{{ $t("message.dispoc.ldispo", { value: "default" }) }}</span>
                                </p>
                                <p>
                                    <span class=" chip A2">A2</span>
                                    <span class="ml-1">{{ $t("message.dispoc.ldmd", { value: "default" }) }}</span>
                                </p>
                                <p>
                                    <span class=" chip B1">B1</span>
                                    <span class="ml-1">{{ $t("message.dispoc.lmp", { value: "default" }) }}</span>
                                </p>
                                <p>
                                    <span class=" chip B2">B2</span>
                                    <span class="ml-1">{{ $t("message.dispoc.lmc", { value: "default" }) }}</span>
                                </p>
                                <p>
                                    <span class=" chip C1">C1</span>
                                    <span class="ml-1">{{ $t("message.dispoc.lach", { value: "default" }) }}</span>
                                </p>
                                <p>
                                    <span class=" chip C2">C2</span>
                                    <span class="ml-1 font-weight-medium">{{ $t("message.dispoc.lmcc", {
                                        value:
                                            "default"
                                    }) }}</span>
                                </p>

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <!--Widget end-->
                <!-- table et dialog -->
                <availability-table :headers="headers" :items="data" :assets="assets" @cell-click="openCellDetail"
                    :pmRate="pmRate" :mcRate="mcRate" :mccRate="mccRate" />
                <cell-detail-dialog :dialog.sync="detailDialog" :cell="selectedCell" :assets="assets" />

            </div>
        </div>
    </v-app>
</template>

<script>
import PortalSysbar from '@/components/PortalSysbar';
import PortalAside from '@/components/PortalAside';
import PortalTitle from '@/components/PortalTitle';
import PortalBreadcumb from '@/components/PortalBreadcumb';
import ApexCharts from 'vue-apexcharts';
import AvailabilityTable from '@/components/AvailabilityTable.vue';
import CellDetailDialog from '@/components/CellDetailDialog.vue';
import { mapActions, mapGetters } from 'vuex';
import { getMonthDetails, dateBetween, isSame, formatMagicDate } from "@/shared/DateHelper"
import MaximoService from "@/services/MaximoService";
import CoreService from "../services/CoreService";
import { CsvUtils } from "../shared/CsvUtils";

export default {
    name: 'DisponibilityContractuelle',
    watch: {
        getterCurrentClient() {
            if (!this.payload.date) {
                return;
            }
            this.loadAssignments(this.payload?.date);
        },
        'payload.date': function (val, old) {
            if (!val || val === old) {
                return;
            }
            this.loadAssignments(val);
        }
    },
    components: {
        PortalSysbar,
        PortalAside,
        PortalTitle,
        PortalBreadcumb,
        ApexCharts,
        AvailabilityTable,
        CellDetailDialog
    },
    data: () => ({
        detailDialog: false,
        selectedCell: {},
        options: {},
        data: [],
        expBtn: true,
        loading: false,
        date: new Date().toISOString().substr(0, 7),
        calendar: [],
        headers: [],
        assets: [],
        avalaibility: [],
        avcal: [],
        menu: false,
        loco: '185',
        agreements: [],
        payload: {},
        dgSeries: [],
        cpSeries: [],
        cmSeries: [],
        dcSeries: [],
        labels: ["17"],
        pmRate: [],
        mccRate: [],
        mcRate: [],
        dispList: new Map(),
        preventive: true,
        icpg: 0,
        icmg: 0,
        icmcg: 0,
        dg: 0,
        sheets: [],
        fill: {
            colors: ["#ff00ff"],
        },
        chartOptions: {
            chart: {
                type: "radialBar",
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: "60%",
                    },
                    track: {
                        background: "#ccd2d5",
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            show: true,
                            offsetY: 5,
                            fontSize: "15px",
                            color: "#00475a",
                        },
                    },
                },
            },
            fill: {
                colors: ["#ff0000"],
            },
        },
        dgChartOptions: {
            chart: {
                type: "radialBar",
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: "60%",
                    },
                    track: {
                        background: "#ccd2d5",
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            show: true,
                            offsetY: 10,
                            fontSize: "30px",
                            color: "#00475a",
                        },
                    },
                },
            },
            fill: {
                colors: ["#7FC7B2"],
            },
        }
    }),
    methods: {
        openCellDetail(cell) {
            this.selectedCell = cell;
            this.detailDialog = true;
        },

        ...mapActions("auth", {
            actionGetContratsDates: "loadContratsDates",
        }),
        nonCountables(item) {
            // nombre de cellules non-countables sur la ligne
            return Object.values(item).filter(v => !v.countable).length;
        },
        calculDispoCell(item) {
            // idem calculDispo mais sur un seul item, si besoin
            const disp = [];
            Object.entries(item).forEach(([v], i) => {
                if (i > 2 && v.countable && v.ind !== 'B2') disp.push(v.ind);
            });
            return disp.length;
        },

        addDialog(ind) {
            if (ind.workorders != undefined || ind.srs != undefined) {
                return "@click='loadDialog()'"
            }
        },
        itemto(item) {

            let arr = Object.entries(item)
            let str = ''
            let disp = []
            let cdate = arr[1][1]
            let ac = 0;
            for (let i = 0; i < arr.length; i++) {
                let ind = arr[i][1]
                if (i == 0) {
                    str += "<td >" + ind + "</td>"
                } else if (i > 2) {

                    if (!ind.countable) {
                        ac++;

                        if (ind.ind == '' || ind.ind == null) {
                            str += "<td class='cell-text-center' ></td>"
                        } else {
                            str += "<td class='cell-text-center'></td>"
                        }
                    } else {

                        str += "<td class='cell-text-center'><span class='chip "
                            + ind.ind + "'>" + ind.ind + "</span></td>"
                        disp.push(ind.ind)
                    }
                }
            }
            //str += "<td class='cell-text-center'>" + this.calculDispo(disp) + "</td>"
            //str += "<td class='cell-text-center'>" + (this.assets.length - ac) + "</td>"
            this.dispList.set(formatMagicDate(cdate), this.calculDispo(disp) + "*" + (this.assets.length - ac));

            return str
        },
        percent(item) {
            return Math.round(this.zeroDiv(item.rate, item.days) * 100) + " %"
        },

        getGlobal(rates) {
            let t = rates.reduce((acc, curr) => acc + this.zeroDiv(curr.rate, curr.days), 0)
            return Number.parseFloat(100 * t / rates.length).toFixed(2)
        },

        zeroDiv(n1, n2) {
            if (n2 == 0) {
                return 0
            }
            return n1 / n2
        },

        ipercent(item) {
            return Math.round(100 - this.zeroDiv(item.rate, item.days) * 100) + " %"
        },

        buildExportData() {
            let data = []

            data.push(
                [this.$t("message.dispoc.dispGen", { value: "default" }),
                this.$t("message.dispoc.indisponibilite", { value: "default" })
                + " " + this.$t("message.dispoc.causeCorrective", { value: "default" }),
                this.$t("message.dispoc.indisponibilite", { value: "default" })
                + " " + this.$t("message.dispoc.causePreventive", { value: "default" }),
                this.$t("message.dispoc.indisponibilite", { value: "default" })
                + " " + this.$t("message.dispoc.causeClient", { value: "default" })
                ])

            data.push(
                [this.dgSeries[0] + '%',
                this.cmSeries[0] + '%',
                this.cpSeries[0] + '%',
                this.dcSeries[0] + '%']
            )
            data.push([])
            data.push([])
            let head = this.headers.map(h => h.text)
            head.unshift(this.$t("message.dispoc.week", { value: "default" }))
            data.push(head)

            this.data.forEach(rowObj => {
                const values = Object.values(rowObj);
                // a) Semaine et jour
                const weekValue = values[2];
                const dayValue = values[0];

                const line = [weekValue, dayValue];

                // b) Pour chaque cellule d’asset (à partir de l’index 3)
                values.slice(3).forEach(cell => {
                    line.push(cell.countable ? cell.ind : "");
                });

                // c) Calcul dynamique « Disponibilité » et « Total actif »
                let dispoCount = 0;
                let totalCount = 0;
                values.slice(3).forEach(cell => {
                    if (cell.countable) {
                        totalCount++;
                        if (cell.ind !== 'B2') {
                            dispoCount++;
                        }
                    }
                });
                line.push(dispoCount, totalCount);

                data.push(line);
            });

            data.push([]);

            head = [""]
            head.push(this.$t("message.dispoc.recapLoc", { value: "default" }))
            for (let i = 0; i < this.mcRate.length; i++) {
                head.push(this.ipercent(this.mcRate[i]))
            }
            data.push(head)

            head = [""]
            head.push(this.$t("message.dispoc.ticmp", { value: "default" }))
            for (let i = 0; i < this.pmRate.length; i++) {
                head.push(this.percent(this.pmRate[i]))
            }
            data.push(head)

            head = [""]
            head.push(this.$t("message.dispoc.timcc", { value: "default" }))
            for (let i = 0; i < this.mcRate.length; i++) {
                head.push(this.percent(this.mcRate[i]))
            }
            data.push(head)

            head = [""]
            head.push(this.$t("message.dispoc.ticc", { value: "default" }))
            for (let i = 0; i < this.mccRate.length; i++) {
                head.push(this.percent(this.mccRate[i]))
            }
            data.push(head)
            return data
        },

        getItemvAlue(item) {
            if (item.countable) {
                return item.ind
            }
            return ""
        },

        download() {
            const blob = new Blob([CsvUtils.buildCsv(this.buildExportData())], { type: 'text/csv' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = this.payload.date + " " + this.payload.agreement + ".csv"
            link.click()
            URL.revokeObjectURL(link.href)
        },

        calculDispo(disp) {
            return disp.reduce((acc, curr) => {
                if (curr == 'B2' || curr == '') {
                    return acc
                }
                return acc + 1
            }, 0)
        },
        getPmRate(asset) {
            return {
                asset: asset,
                days: this.getTotalDay(asset),
                rate: this.avalaibility.reduce(
                    (acc, curr) => {
                        let arr = Object.entries(curr)
                        for (let i = 3; i < arr.length; i++) {
                            if ((arr[i][0] == asset) && (arr[i][1].ind == 'B1') && (arr[i][1].countable)) {
                                return acc + 1
                            }
                        }
                        return acc
                    }, 0
                )
            }
        },
        getMccRate(asset) {
            return {
                asset: asset,
                days: this.getTotalDay(asset),
                rate: this.avalaibility.reduce(
                    (acc, curr) => {
                        let arr = Object.entries(curr)
                        for (let i = 3; i < arr.length; i++) {
                            if ((arr[i][0] == asset) && (arr[i][1].ind == 'C2') && (arr[i][1].countable)) {
                                return acc + 1
                            }
                        }
                        return acc
                    }, 0
                )
            }
        },
        getTotalDay(asset) {
            return this.avalaibility.reduce(
                (acc, curr) => {
                    let arr = Object.entries(curr)
                    for (let i = 3; i < arr.length; i++) {
                        if ((arr[i][0] == asset) && (arr[i][1].ind != '') && (arr[i][1].countable)) {
                            return acc + 1
                        }
                    }
                    return acc
                }, 0
            )
        },
        getMcRate(asset) {
            return {
                asset: asset,
                days: this.getTotalDay(asset),
                rate: this.avalaibility.reduce(
                    (acc, curr) => {
                        let arr = Object.entries(curr)
                        for (let i = 3; i < arr.length; i++) {
                            if ((arr[i][0] == asset) && ((arr[i][1].ind == 'C2') || (arr[i][1].ind == 'B2')) && (arr[i][1].countable)) {
                                return acc + 1
                            }
                        }
                        return acc
                    }, 0
                )
            }
        },
        getStyle(status) {
            if (status) {
                return 'border-bottom: unset; background-color:' + this.getBgColor
            }
            return 'border-bottom: 1px solid black; background-color:' + this.getBgColor
        },
        async loadAssignments(date) {
            await this.actionGetContratsDates({
                client: this.getterCurrentClient,
                date: date
            })
            this.agreements = this.getterContrats;
        },
        findIndicator(date, asset) {
            return this.avcal.find((elt) => {
                return isSame(date, elt.date) && (elt.locomotive == asset)
            })
        },
        buildAvObj(assets, c) {
            let obj = {}

            obj.day = c.date
            obj.date = c.longdate
            obj.week = c.week
            for (var i = 0; i < assets.length; i++) {
                let asset = assets[i]
                if (dateBetween(c.longdate, new Date(asset.startdate), new Date(asset.enddate))) {
                    let rep = this.findIndicator(c.longdate, asset.assetnum)

                    if (rep == undefined) {
                        obj[asset.assetnum] = {
                            ind: 'A1',
                            countable: true
                        }
                    } else {
                        obj[asset.assetnum] = {
                            ind: rep.indicator == null ? 'A1' : rep.indicator,
                            countable: rep.countable,
                            workorders: rep.workorders,
                            memos: rep.memos
                        }
                    }
                } else {
                    obj[asset.assetnum] = {
                        ind: '',
                        countable: false
                    }
                }
            }
            return obj
        },
        buildAvailability(assets) {
            this.cmSeries = []
            this.dgSeries = []
            this.cpSeries = []
            this.dcSeries = []
            this.avalaibility = this.calendar.map(c => this.buildAvObj(assets, c))
            this.pmRate = this.assets.map(a => this.getPmRate(a.assetnum))
            this.mccRate = this.assets.map(a => this.getMccRate(a.assetnum))
            this.mcRate = this.assets.map(a => this.getMcRate(a.assetnum))
            this.cmSeries.push(this.getGlobal(this.mcRate))
            this.cpSeries.push(this.getGlobal(this.pmRate))
            this.dcSeries.push(this.getGlobal(this.mccRate))
            if (this.preventive) {
                this.dgSeries.push(Number.parseFloat(100 - this.cmSeries[0]).toFixed(1))
            } else {
                this.dgSeries.push(Number.parseFloat(100 - this.cmSeries[0] - this.cpSeries[0]).toFixed(1))
            }

            this.data = this.avalaibility
            this.loading = false
        },
        async loadAvailabilityData() {
            this.avcal = []
            var [year, month] = this.payload.date.split("-")
            CoreService.loadAvailabilityCal(this.payload.agreement, year, month).then(response => {
                this.avcal = response.data
            })
        },

        async getPreventive(agreement) {
            this.preventive = true;
            CoreService.getPreventiveRate(agreement).then(
                response => {
                    this.preventive = response.data.preventiveRate
                }
            )
        },

        buildHeader(data) {
            this.headers = data.map(asset => ({
                text: asset.assetnum,
                locomotive: asset.assetnum,
                lstatus: asset.contractualStatus,
                ecm: asset.maintainer.name,
                value: asset.assetnum,
                sortable: false,
                divider: false,
                width: '500px'
            }));
            this.headers.unshift({
                text: "",
                value: "day",
                width: '200px'
            })

        },
        async loadData() {
            var [year, month] = this.payload.date.split("-")
            await this.getPreventive(this.payload.agreement)
            await this.getCalendar(year, month)
            this.expBtn = true
            this.loading = true
            this.data = []
            this.dispList = new Map()

            await this.loadAvailabilityData()


            const response = await MaximoService.loadLeasingAsssetByAgreement(this.payload.agreement, this.payload.date);

            this.assets = response.data
            await this.buildHeader(response.data)
            await this.buildAvailability(response.data)
            this.expBtn = false
        },

        openDetail(item) {
            this.selectedItem = item;     // on stocke l’item
            this.detailDialog = true;     // on ouvre la dialog
        },

        async getCalendar(year, month) {
            this.calendar = getMonthDetails(year, month, this.$i18n.locale)
        }
    },
    computed: {
        ...mapGetters('auth', {
            getterContrats: 'getContractDates',
            getterCurrentClient: 'getCurrentClient'
        }),
        ...mapGetters("customer", {
            getterLocos: "getFilterLoc",
        }),

        getColspan() {
            return 100
        },

        getBgColor() {
            return '#f0f1f5'
        },

        filteredSelectedEntries() {
            if (!this.selectedItem) return [];
            // transforme l’objet en tableau [clé, valeur] puis filtre
            return Object.entries(this.selectedItem)
                .filter(([key]) => key !== 'day' && key !== 'week');
        },
    },
    mounted() {
    }
};
</script>

<style>
.chip {
    padding: 10px;
    background-color: #fff;
    box-shadow: -5px 4px 10px 0 rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 1em 1.75em;
    font-size: 11px;
    font-weight: bold;
    background-color: var(--disponibility-color);
    color: var(--disponibility-text-color);
    font-weight: bold;
    --disponibility-text-color: white;
    --bleu-900: #5570F1FF;

    &.A1 {
        --disponibility-text-color: black;
        --disponibility-color: white;
    }

    &.A2 {
        --disponibility-color: gold;
        --disponibility-text-color: black;
    }

    &.B1 {
        --disponibility-color: var(--bleu-900);
    }

    &.B2 {
        --disponibility-color: red;
    }

    &.C1 {
        --disponibility-color: darkgreen;
    }

    &.C2 {
        --disponibility-color: black;
    }

    &.D1 {
        --disponibility-color: saddlebrown;
    }
}

#dctable {
    border: none;
    background-color: #f0f1f5;
}

#dctable {
    color: #00475A;
}

#dctable.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
#dctable.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    border: unset;
}

#dctable.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover {
    background-color: unset;
}

.noborder {
    border: none;
}

.cell-text-center {
    text-align: center;
}
</style>